export default "__VITE_ASSET__a048ae30__"